export const truncateString = (inputString: string, maxLength: number) => {
  if (inputString && inputString.length <= maxLength) {
    return inputString;
  } else if (inputString && inputString.length > maxLength) {
    return `${inputString.substring(0, maxLength)}...`;
  } else {
    return null;
  }
};
